var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"recent-orders home"},[_c('Navbar'),_c('mini-cart'),_c('recent-orders')],1)}
var staticRenderFns = []

export { render, staticRenderFns }